const arrowIconStyles = {
    root: {
        width: "$s2",
        height: "$s2",
        marginLeft: "2px",
        verticalAlign: "bottom",
    },
};
export { arrowIconStyles };
//# sourceMappingURL=_localVariants.js.map